// Skip links (header.php): after "to the content", one link per section of the
// page, named by the section's heading, so keyboard and screen reader users can
// jump past the menu straight to what they are looking for.
export function initSkipLinks() {
    const list = document.querySelector('.skip-links__list');
    const main = document.getElementById('main');
    if (!list || !main) return;

    const slug = (text) => text.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const seen = new Set();

    main.querySelectorAll('section').forEach((section) => {
        // Top-level sections only (not a section inside a section).
        if (section.parentElement.closest('section')) return;
        // The section's own title; headings of lists inside (months, years, posts) don't count.
        const labelledBy = section.getAttribute('aria-labelledby');
        const heading = (labelledBy && document.getElementById(labelledBy)) || section.querySelector('h2.section-title, h2.cta-band__title');
        const label = (heading?.textContent || section.getAttribute('aria-label') || '').trim().replace(/\s+/g, ' ');
        if (!label || seen.has(label) || heading?.closest('[hidden]')) return;
        seen.add(label);

        if (!section.id) {
            let id = 'section-' + (slug(label) || seen.size);
            while (document.getElementById(id)) id += '-2';
            section.id = id;
        }

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'skip-links__link';
        link.href = '#' + section.id;
        link.textContent = label;
        item.append(link);
        list.append(item);
    });
}
